/**
 * marketplaceRequests store — a minimal cross-component refresh trigger for
 * the marketplace-requests badge/list (M6-B M9.9 operator UX punch list,
 * item 5).
 *
 * `useMarketplaceRequestCount` (the sidebar "Requests" badge) self-fetches
 * once on mount and has no way to learn that a confirm/decline elsewhere in
 * the app changed the pending-request count — the badge went stale until a
 * full page reload. This mirrors the repo's existing lightweight-store idiom
 * (`stores/today.ts`'s module-level `inFlight`/refresh pattern, simplified
 * to just a version counter): mutating call sites (`MarketplaceRequestsPage`,
 * `MarketplaceRequestDetailPage`) call `bumpMarketplaceRequests()` after a
 * successful confirm/decline; any hook subscribed to the store's `version`
 * refetches.
 */
import { create } from "zustand";

interface MarketplaceRequestsRefreshState {
  version: number;
}

export const useMarketplaceRequestsRefreshStore =
  create<MarketplaceRequestsRefreshState>(() => ({ version: 0 }));

/** Call after a successful confirm/decline to signal every subscribed
 * consumer (currently `useMarketplaceRequestCount`) to refetch. */
export function bumpMarketplaceRequests(): void {
  useMarketplaceRequestsRefreshStore.setState((s) => ({
    version: s.version + 1,
  }));
}
